import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { useAppState, HistoryElement } from "@nosto/preact"

export default function History() {
    const { historyItems } = useAppState()

    if (!historyItems || !historyItems.length) {
        return
    }

    return
}
